import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useCmpInit } from '../hooks/useCmpInit';
var ConsentManagementInit = function () {
    var adsEnabled = useContext(SessionContext).adsEnabled;
    useCmpInit({ adsEnabled: adsEnabled });
    return null;
};
ConsentManagementInit.displayName = 'ConsentManagementInit';
export default ConsentManagementInit;
//# sourceMappingURL=ConsentManagementInit.js.map